import { Grid, Link, TableCell, TableRow, Tooltip } from "@material-ui/core";
import React, { useEffect } from "react";
import CarTypeIcon from "../../components/CarTypeIcon";
import ChipContact from "../../components/ChipContact";
import CustomTable from "../../components/CustomTable";
import LoadPage from "../../components/LoadPage";
import PageCustom from "../../components/PageCustom";
import PlatformRequest from "../../utils/PlatformRequest";

const AnsweredListPage = () => {
    const [searches, setSearches] = React.useState([])
    const [load, setLoad] = React.useState(false)
    const [page, setPage] = React.useState({
        currentPage: 0,
        totalItems: 0,
        totalPages: 0
    })

    useEffect(() => {
        loadSearchs(0)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const loadSearchs = (pageNumber) => {
        setLoad(true)
        PlatformRequest.getSearchesPartFound(pageNumber, 10).then((response) => {
            setLoad(false)
            const { body } = response
            setSearches(body.searchList)
            setPage({
                currentPage: body.currentPage,
                totalItems: body.totalItems,
                totalPages: body.totalPages,
            })
        })
    }

    return (
        <PageCustom title="Meus Atendimentos">
            <LoadPage load={load} />
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>

                    <Grid item xs={12} sm={12} md={12}>
                        <CustomTable
                            title={["Tipo", "Descrição", "Cliente", "Contato", "Data"]}
                            pagination={true} page={page}
                            changePage={loadSearchs}
                            items={searches.map((search) => (
                                <TableRow key={search.id} hover>
                                    <Tooltip title={search.carType} placement="top" arrow>
                                        <TableCell align="center">
                                            <CarTypeIcon type={search.carType} />
                                        </TableCell>
                                    </Tooltip>
                                    <TableCell
                                        component={Link}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => { window.open(`/search/${search.id}`, "_blank") }}
                                        scope="row" align="left">
                                        {search.description}
                                    </TableCell>
                                    <TableCell align="left">{search.contactSearch.name !== null ? search.contactSearch.name : "Não Informado"}</TableCell>
                                    <TableCell align="left"><ChipContact contacts={search.contactSearch.contactList} /></TableCell>
                                    <TableCell align="left">{search.createdAt}</TableCell>
                                </TableRow>
                            ))
                            } />
                    </Grid>

                </Grid>

            </Grid>
        </PageCustom>
    )
}

export default AnsweredListPage